


























import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import MusicEditor from './music-editor/index.vue';
import MusicDisplay from './music-display/index.vue';
import LoadingSkeleton from './music-display/loading-skeleton.vue';

type InitMessageData = {
  adv_id: string;
  lang: string;
  image_infos: Array<{
    image_url: string;
    image_name: string;
  }>;
  creative_info: {
    avatar: string;
    nickname: string;
    cta: string;
  };
};

type InitData = {
  caller: string;
  id: string;
  data: InitMessageData;
};

type GetInitDataFunctionType = () => InitData;

type MusicInfo = {
  author: string;
  cover: string;
  duration: number;
  musicId: string;
  playUrl: string;
  title: string;
};

const name = 'ttam-creative-music-carousel-music-compose';
export default defineComponent({
  name,
  components: {
    MusicEditor,
    MusicDisplay,
    LoadingSkeleton,
  },
  props: {
    musicInfo: {
      type: Object as PropType<MusicInfo>,
      default: () => ({}),
    },
    editorTopDistance: {
      type: String,
      default: () => '',
    },
    getInitData: {
      type: Function as PropType<GetInitDataFunctionType>,
      required: true,
      default: () => () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const musicEditor = ref();
    const musicDisplayRef = ref();
    const initData = ref({});
    const musicPlay = () => {
      musicDisplayRef.value?.musicPlayer?.play?.();
    };
    const musicPause = () => {
      musicDisplayRef.value?.musicPlayer?.pause?.();
    };

    const handleSuccess = data => {
      ctx.emit('editor-success', data);
    };

    const hasMusic = computed(() => Boolean(props.musicInfo?.musicId));

    const handleMusicDelete = data => {
      ctx.emit('music-delete', data);
    };

    const handleMusicEdit = () => {
      const openMusicEditor = musicEditor.value?.handleEditorShow;
      openMusicEditor?.();
    };

    return {
      hasMusic,
      initData,
      musicPlay,
      musicPause,
      musicEditor,
      handleSuccess,
      handleMusicEdit,
      musicDisplayRef,
      handleMusicDelete,
    };
  },
});
